import {Injectable}    from '@angular/core';
import 'rxjs/add/operator/toPromise';

declare var $: any;

@Injectable()
export class LoadingService {
    public currentLoader: any;

    public loaderCounter: number = 0;
    public gc = null;

    constructor() {
    }

    show(message?, fullscreen?, force?): Promise<any> {
        if (this.loaderCounter > 0) {
            this.loaderCounter++;
            this.garbage();
            return Promise.resolve(true);
        }

        $('#loader').addClass('shown');
        this.garbage();
        return Promise.resolve(true);
    }

    garbage() {
        if(this.gc) {
            clearTimeout(this.gc);
        }
        this.gc = setTimeout(() => {
            this.hide(true);
        }, 2500)
    }

    hide(force?) {
        this.loaderCounter --;
        if(this.loaderCounter < 0) {
            this.loaderCounter = 0;
            $('#loader').removeClass('shown');
        }else{
            this.garbage();
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/service/loading.ts